/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

// Based on
// https://stackoverflow.com/questions/65439066/using-google-one-tap-in-angular
import { Component, AfterViewInit, EventEmitter, Output, Renderer2, Inject } from '@angular/core';
import { CredentialResponse } from 'google-one-tap'
import { AuthService } from '../../services/auth.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { DriftService } from '../../services/drift.service';
import { DOCUMENT } from '@angular/common';
import { JwtHelper } from 'angular2-jwt';
import { environment } from '../../../environments/environment';


declare const google: any;
declare const window: any;

@Component({
  selector: 'google-login',
  templateUrl: './google-login.component.html'
})
export class GoogleLoginComponent implements AfterViewInit {

  @Output() notifyLoginInvalid: EventEmitter<string> = new EventEmitter<string>();

  clientId: string = environment.googleClientId;

  jwtHelper = new JwtHelper();
  validCreds: boolean = false;


  constructor(
              private authService: AuthService,

              private driftService: DriftService,
              private globalMessageService: GlobalMessageService,
              private _renderer2: Renderer2,
              @Inject(DOCUMENT) private _document: Document,
              private errorService: ErrorService) { }

    ngAfterViewInit() {
      const gsiScript = this._renderer2.createElement('script');
        gsiScript.src = `https://accounts.google.com/gsi/client`;
        gsiScript.async = `true`;
        gsiScript.defer = `true`;
        this._renderer2.appendChild(this._document.body, gsiScript);
    }
    ngOnInit(): void {
      window.onGoogleLibraryLoad = () => {

        google.accounts.id.initialize({
          client_id: this.clientId,
          callback: this.handleLogin.bind(this),
          auto_select: false,
          cancel_on_tap_outside: true,
        })

        google.accounts.id.renderButton( document.getElementById('gsiLoginButton'), { theme: 'outline', size: 'large', width: 200 } )
      }
    }

  handleLogin(credential: CredentialResponse) {
    const decodedToken = this.jwtHelper.decodeToken(credential.credential);
    const email = decodedToken.email;

    this.authService.loginGoogle(email, credential.credential).subscribe(
      () => {


        this.driftService.identify();
        this.driftService.track('logged-in', { type: 'google' });
      },
      err => {
        // Invalid user
        if (err.status == 404) {
          this.notifyLoginInvalid.emit(email);
          this.validCreds = false;
        }
        else {
          // some other server error, needs to be logged
          this.globalMessageService.error();
          this.errorService.log(err, 'login.component', 'onSubmit');
        }
      }
    )
  }

}



// WEBPACK FOOTER //
// ./client/app/login/google-login/google-login.component.ts